// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"215c7f58","304":"b9aff33d","509":"d3dc4065","616":"3802797d","683":"661e3eb5","894":"ff1df65e"}[chunkId] + ".chunk.css";
};